// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, createUserWithEmailAndPassword } from "firebase/auth"

const firebaseConfig = {
  apiKey: "AIzaSyCWB-pRjGKaioIyD7383_Gte2k5B4shyu4",
  authDomain: "aicrawl-41899.firebaseapp.com",
  projectId: "aicrawl-41899",
  storageBucket: "aicrawl-41899.firebasestorage.app",
  messagingSenderId: "924199315721",
  appId: "1:924199315721:web:acbe0eed16f50293554bd8",
  measurementId: "G-DDFG6VH0TP"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app)
const provider = new GoogleAuthProvider();


export default db
export { auth, provider, createUserWithEmailAndPassword }